<template>
    <div class="container-fluid">
        <Breadcrumb title="Mail Services Report" v-bind:button-show="false"></Breadcrumb>
        <div class="row" style="position: relative">
            <div class="col-12">
                <div class="card">
                    <div class="card-body">
                        <div class="input-group form-group">
                            <label>Date Range</label>
                                <date-picker v-model="range" range style="width:100%;" :lang="datePickerConf"></date-picker>
                        </div>
                        <div class="input-group form-group" v-if="isAdmin">
                            <label>User</label>
                            <treeselect placeholder="All"
                                        v-model="filter.userId"
                                        :multiple="false"
                                        :options="userList"
                                        :load-options="loadUserList"
                                        :auto-load-root-options="true"
                            />
                        </div>
                        <div class="form-row">
                            <div class="col-2">
                                <button class="btn btn-info btn-rounded text-uppercase waves-effect waves-light w-100"
                                        @click="getItems()">
                                    Get
                                </button>
                            </div>
                        </div>
                    </div>
                    <div class="card-body">
                        <div class="col-12" v-if="loading" style="min-height:100px;">
                            <Preloader v-bind:class="{preloader: loading}"></Preloader>
                        </div>
                        <div v-else>
                            <div v-if="report.length === 0">{{emptyMessage}}</div>
                            <div v-else>
                                <div>
                                    <div class="table-responsive">
                                        <table class="table">
                                            <thead>
                                            <tr>
                                                <th @click="tableOrdering('provider_name')">
                                                    <span role='button'>Mail Service</span>
                                                </th>
                                                <th @click="tableOrdering('delivered')">
                                                    <span role='button'>Sent</span>
                                                </th>
                                                <th @click="tableOrdering('views')">
                                                    <span role='button'>Open</span>
                                                </th>
                                                <th @click="tableOrdering('clicks')">
                                                    <span role='button'>Click</span>
                                                </th>
                                                <th @click="tableOrdering('conversions')">
                                                    <span role='button'>Conversion</span>
                                                </th>
                                                <th @click="tableOrdering('open_rate')">
                                                    <span role='button'>Open Rate</span>
                                                </th>
                                                <th @click="tableOrdering('click_rate')">
                                                    <span role='button'>Click Rate</span>
                                                </th>
                                                <th @click="tableOrdering('conv_rate')">
                                                    <span role='button'>Conv Rate</span>
                                                </th>
                                                <th @click="tableOrdering('profit')">
                                                    <span role='button'>Profit</span>
                                                </th>
                                            </tr>
                                            </thead>
                                            <tbody>
                                            <tr v-for="(line, index) in report" :key="index">
                                                <td class="align-middle">{{line.provider_name}}</td>
                                                <td class="align-middle">{{line.delivered}}</td>
                                                <td class="align-middle">{{line.views}}</td>
                                                <td class="align-middle">{{line.clicks}}</td>
                                                <td class="align-middle">{{line.conversions}}</td>
                                                <td class="align-middle">{{line.open_rate}} %</td>
                                                <td class="align-middle">{{line.click_rate}} %</td>
                                                <td class="align-middle">{{line.conv_rate}} %</td>
                                                <td class="align-middle">{{line.profit}}</td>
                                            </tr>
                                            </tbody>
                                        </table>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    import Treeselect from '@riophae/vue-treeselect';
    import Swal from 'sweetalert2'
    import Preloader from '../components/Preloader';
    import Breadcrumb from '../components/Breadcrumb';
    import ReportService from '../services/ReportService';
    import UserService from '../services/UserService';
    import DatePicker from 'vue2-datepicker';
    import moment from 'moment';

    export default {
        name: 'MailProviderReport',
        components: {
            Treeselect,
            Breadcrumb,
            Preloader,
            DatePicker
        },
        data() {
            return {
                emptyMessage: '',
                totalItems: 0,
                report: [],
                userList: null,
                filter: {
                    userId: null,
                    orderBy: 'profit',
                    direction: 'desc',
                    toDate: null,
                    fromDate: null
                },
                loading: false,
                isAdmin: false,
                range: [moment().subtract(7, 'days').toDate(), moment().toDate()],
                datePickerConf: {
                    formatLocale: {
                        firstDayOfWeek: 1,
                    },
                },
            }
        },
        mounted() {
            this.isAdmin = this.$store.getters.isAdmin;
            if (!this.isAdmin) {
                this.getItems(this.page);
            }
        },
        methods: {
            loadUserList({callback}) {
                UserService.getUserSelect().then(response => {
                    this.userList = response.data['hydra:member'].map(user => {
                        return {id: user.id, label: user.username}
                    });
                    callback();
                });
            },
            getItems: function () {
                this.filter.fromDate = moment(this.range[0]).format('YYYY-MM-DD');
                this.filter.toDate = moment(this.range[1]).format('YYYY-MM-DD');
                this.loading = true;
                ReportService.getMailProviderReport(JSON.stringify(this.filter)).then(response => {
                    this.report = response.data.report;
                    if (this.report.length === 0) {
                        this.emptyMessage = 'Nothing to show.'
                    } else {
                        this.emptyMessage = ''
                    }
                    this.loading = false;
                }).catch(error => {
                    Swal({
                        type: 'error',
                        title: 'Oops...',
                        text: `${error}`,
                    });
                    this.loading = false;
                });
            },
            tableOrdering(field) {
                if (this.filter.orderBy === field) {
                    this.filter.direction = (this.filter.direction === 'asc') ? 'desc' : 'asc';
                } else {
                    this.filter.orderBy = field;
                    this.filter.direction  = 'desc';
                }
                this.getItems();
            }
        }
    }
</script>

<style scoped>
    tbody {
        font-size: 14px;
        font-family: Arial, serif;
        margin-left: 20px;
    }
    td {
        padding-left: 20px;
    }
</style>
